import {
  LineupConfig as Config,
  filterPosition,
  getUpdateLineupsPayload,
  LineupModel,
  toSortedBySurname,
  updateLineups,
} from '@collector/desktop-feature-lineups'
import { Events } from '@collector/sportsapi-client'
import {
  ParticipantSubType,
  SubParticipantPosition,
} from '@collector/sportsapi-client-legacy'
import { Event, Participant, SubParticipant } from '@collector/sportsapi-types'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'

import { LineupConfig } from '../../configuration'

export type PositionKey = 'player' | 'coach' | 'willNotPlay'
export type VolleyballLineupModel = LineupModel<PositionKey>
export type VolleyballLineupConfig = Config<PositionKey>

export const lineupConfig: LineupConfig = {
  config: {
    addPlayer: {
      addAllTargets: [],
      addAllConfirmText:
        'Do you want to add all season squad as players and pick coach?',
      searchPlaceholder: 'Player name',
    },
    positions: {
      player: {
        sectionLabel: 'Players',
        showCaptainRadio: false,
        showShirtNr: true,
        showDeleteAll: false,
        buttonLabel: 'PLA',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
        addFoundPlayer: {
          confirmMissingShirtNr: true,
          disableForSubTypes: [ParticipantSubType.Coach],
        },
      },
      coach: {
        sectionLabel: 'Coach',
        maxCount: 1,
        maxCountReasonText: 'Coach is already added',
        buttonLabel: 'COA',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
      },
      willNotPlay: {
        deleteOnly: true,
        showDeleteAll: false,
        sectionLabel: 'Will not play',
        buttonLabel: '',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
      },
    },
  },
  createLineupModel(players: SubParticipant[]): VolleyballLineupModel {
    return {
      player: filterPosition(players, SubParticipantPosition.Player),
      coach: filterPosition(players, SubParticipantPosition.Coach),
      willNotPlay: filterPosition(players, SubParticipantPosition.WillNotPlay),
    }
  },
  toSortedLineupModel(lineup: LineupModel<PositionKey>): VolleyballLineupModel {
    return {
      player: toSortedBySurname(lineup.player),
      coach: [...lineup.coach],
      willNotPlay: [...lineup.willNotPlay],
    }
  },
  async updateLineups(
    eventId: Event['id'],
    participantId: Participant['id'],
    lineup: LineupModel<PositionKey>,
  ): Promise<void> {
    const squad: Events.SubParticipantsSave.SubParticipantsSavePostSquad[] = [
      ...getUpdateLineupsPayload(lineup.player, SubParticipantPosition.Player),
      ...getUpdateLineupsPayload(lineup.coach, SubParticipantPosition.Coach),
      ...getUpdateLineupsPayload(
        lineup.willNotPlay,
        SubParticipantPosition.WillNotPlay,
      ),
    ]

    await updateLineups(sportsApiClient, eventId, participantId, squad)
  },
}
